import Vue from 'vue'
import VueRouter from 'vue-router'
import PeopleManagement from '../../src/views/PeopleManagement/PeopleManagement'
import OrganizationManage from '../../src/views/OrganizationManage'
import PrjOrganizationManage from '../../src/views/PrjOrganizationManage'
import BaseUserManage from '../../src/views/BaseUserManage'
import QualityFormConfiguration from '../../src/views/QualityFormConfiguration'
import Todo from '../../src/views/Todo'
import warnMessage from '../../src/views/warnMessage'
import tooltipInfo from '../../src/views/TooltipInfo'
import NotFound from '../components/404'
import roles from '../views/roles'
import resource from '../views/Resources.vue'
import warnmanage from '../views/warnManage'
import ukManage from '../views/UkManage'
import enumManage from '../views/EnumManage'
import LoginConfig from '../views/LoginConfig'
import axios from 'axios';
import {getConfigAsync} from "../js/common.js"
import Copydo from "../../src/views/Copydo";
import barSimple from "../components/echarts/BarSimple"
import summary from './../views/Summary/Summary'
import modularMain from './../views/modularMain.vue'
import modularMainMl from './../views/modularMainMl.vue'
import modularMainMl2 from './../views/modularMainMl2.vue'
import orgTree from './../views/orgTree/orgTree.vue'
import organization from './../views/orgTree/organization.vue'
import pageConfig from './../views/pageConfig.vue'
import cockpitCh from './../views/cockpitCh.vue'
import cockpitGd from './../views/cockpitGd.vue'
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'login',
  //   component: () => import('../../src/views/Login.vue'),

  // },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('../../src/views/Login2.vue')
  // },
  {
    path: '/ca',
    name: 'loginCa',
    component: () => import('../../src/views/JXLogin.vue')
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      requireAuth: true,  // 需要登录的
    },
    component: () => import('../../src/views/Home.vue')
  },{
  path: '/homeOld',
  name: 'home',
  meta: {
    requireAuth: true,  // 需要登录的
  },
  component: () => import('../../src/views/HomeOld.vue')
},
  {
    path: '/defaultImg',
    name: 'defaultImg',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/defaultImg')
  },
  {
    path: '/defaultImgByConfig',
    name: '跟踪问效主页信息',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/defaultImgByConfig')
  },
  {
    path: '/systemInfo',
    name: 'systemInfo',
    meta: {
      requireAuth: true
    },
    component: () => import('../views/SystemInfo2')
  },

    {
        path: '/LogOption',
        name: 'LogOption',
        meta: {
            requireAuth: true
        },
        component: () => import('../views/LogOption')
    },
    {
        path: '/LoginInfo',
        name: 'LoginInfo',
        meta: {
            requireAuth: true
        },
        component: () => import('../views/LoginInfo')
    },
  {
    path: '/PeopleManagement',
    name: '人员管理',
    meta: {
      requireAuth: true
    },
    component: PeopleManagement
  },
  {
    path: '/OrganizationManage',
    name: '组织机构',
    meta: {
      requireAuth: true
    },
    component: OrganizationManage
  },
  {
    path: '/PrjOrganizationManage',
    name: 'PrjOrganizationManage',
    meta: {
      requireAuth: true
    },
    component: PrjOrganizationManage
  },
  {
    path: '/BaseUserManage',
    name: '人员管理',
    meta: {
      requireAuth: true
    },
    component: BaseUserManage
  },
  {
    path: '/QualityFormConfiguration',
    name: 'QualityFormConfiguration',
    component: QualityFormConfiguration
  },
  {
    path: '/roles',
    name: '角色管理',
    meta: {
      requireAuth: false
    },
    component: roles
  },
  {
    path: '/rolesType',
    name: '角色类型',
    meta: {
      requireAuth: false
    },
    component: () => import('../views/rolesType')
  },
  {
    path: '/resource',
    name: '资源管理',
    meta: {
      requireAuth: true
    },
    component: resource
  },
  {
    path: '/ukManage',
    name: 'UK管理',
    component: ukManage
  },
  {
    path: '/enum',
    name: '枚举管理',
    component: enumManage
  },
  {
    path: '/loginConfig',
    name: '页面配置',
    component: LoginConfig
  },

  {
    path: '/todo',
    name: '待办',
    meta: {
      requireAuth: true
    },
    component: Todo
  },
  {
    path: '/warnmanage',
    name: '安全预警配置',
    component: warnmanage
  },
  {
    path: '/warnMessage',
    name: '预警消息',
    meta: {
      requireAuth: true
    },
    component: warnMessage
  },
  {
    path: '/tooltipInfo',
    name: '消息提示',
    meta: {
      requireAuth: true
    },
    component: tooltipInfo
  },
    {
        path: '/copydo',
        name: '抄送',
        meta: {
            requireAuth: true
        },
        component: Copydo
    },
  {
    path: '/summary',
    name: '汇总',
    meta: {
      requireAuth: true
    },
    component: summary
  },
  {
    path: '/loginLog',
    name: '登录日志',
    meta: {
      // requireAuth: true
    },
    component: () =>
				import ('../views/systemSetting/LoginLog.vue')
  },
  {
    path: '/LoginLogShowTree',
    name: '登录日志-累计登录树形态',
    meta: {
      // requireAuth: true
    },
    component: () =>
				import ('../views/systemSetting/LoginLogShowTree.vue')
  },

  {
    path: '/accessLog',
    name: '访问日志',
    meta: {
      // requireAuth: true
    },
    component: () =>
				import ('../views/systemSetting/AccessLog.vue')
  },
  {
    path: '/jumpTable',
    name: '跳转详情界面',
    component: () =>
				import ('../views/jumpTable/index.vue')
  },
  {
    path: '/indexMaterial',
    name: '跳转详情界面-材料',
    component: () =>
				import ('../views/jumpTable/indexMaterial.vue')
  },
  // {
  //   path: '/modularMain',
  //   name: '主要模块',
  //   component: () =>
	// 			import ('../views/modularMain.vue')
  // },
  {
    path: '/modularMain',
    name: '登录页',
    component: () =>
      // import ('../views/modularMain219.vue')
      //
      import ('../views/modularMain.vue')
  },
  {
    path: '/login1',
    name: '主要模块',
    component: () =>
      import ('../views/modularMainMl.vue')
  },
  {
    path: '/login',
    name: '主要模块',
    component: () =>
      import ('../views/modularMainMl2.vue')
  },
  {
    path: '/zzhb',
    name: '主要模块',
    component: () =>
				import ('../components/modularMain/zzhb.vue')
  },
  {
    path: '/xmzhb',
    name: '主要模块',
    component: () =>
				import ('../components/modularMain/xmzhb.vue')
  },
  {
    path: '/xmgs',
    name: '主要模块',
    component: () =>
				import ('../components/modularMain/xmgs.vue')
  },
  {
    path: '/cjdw',
    name: '主要模块',
    component: () =>
				import ('../components/modularMain/cjdw.vue')
  },
  {
    path: '/orgCh',
    name: '组织机构CH',
    component: () =>
      import ('../components/modularMain/orgCh.vue')
  },
  {
    path: '/calendarEvents',
    name: '大事纪要列表',
    component: () =>
				import ('../components/modularMain/calendarEvents.vue')
  },
  {
    path: '/calendarEventList',
    name: '大事纪要列表',
    component: () =>
				import ('../components/modularMain/calendarEventList.vue')
  },
  {
    path: '/calendarEventsInfo',
    name: '大事纪要详情',
    component: () =>
				import ('../components/modularMain/calendarEventsInfo.vue')
  },
  {
    path: '/usageStatis',
    name: '数据量统计',
    meta: {
      // requireAuth: true
    },
    component: () =>
				import ('../views/systemSetting/UsageStatis.vue')
  },
  {
    path: '/test',
    name: 'test',
    component: () =>
				import ('../views/test.vue')
  },
  {
    path: '/imitateLogin',
    name: '模拟登录',
    component: () =>
				import ('../views/imitateLogin.vue')
  },
  {
    path: '*',
    name: '404',
    component: NotFound
  },
  {
    path: '/barSimple',
    name: 'echart示例',
    component: barSimple
  },
  {
    path: '/orgTree',
    name: '行政组织',
    component: orgTree
  },
  {
    path: '/organization',
    name: '总指挥部',
    component: organization
  },{
    path: '/pageConfig',
    name: '页面配置',
    component: pageConfig
  },{
    path: '/cockpitCh',
    name: '驾驶舱',
    component: cockpitCh
  },{
    path: '/cockpitChMove',
    name: '驾驶舱动态版',
    component: () =>
				import ('./../views/cockpitChMove.vue')
  },{
    path: '/cockpitGd',
    name: '驾驶舱使用',
    component: cockpitGd
  },{
    path: '/socketIo',
    name: '驾驶舱动态版',
    component: () => import ('./../views/socketIo.vue')
  },
  {
    path: '/ztHomePage',
    name: '首页',
    component: () => import('@/views/ztHomePage/ztHomePage.vue')
},{
    path: '/homePic',
    name: '首页',
    component: () => import('@/views/FirstPage.vue')
  },{
    path: '/tempImg',
    name: '样例',
    component: () => import('@/views/TempImg.vue')
  }
]

const router = new VueRouter({
    // base: '/gd/',
  mode: 'history',
  routes
});

//5-14 判断环境-打包不用注释，直接打包
router.beforeEach((to, from, next) => {
  // 访问80端口，直接跳转到登录界面
  if(to.path==="/"){
    //开发环境，直接next
    if (process.env.NODE_ENV === 'development') {
      next();
      return;
    }
    //重定向登录界面
    getConfigAsync().then(res=>{
      //退出地址，通过配置文件配置
      let hostUrl = window.location.host;
      let protocol = window.location.protocol;
      if (res.logoutUrl && res.logoutUrl != "") {
        window.location.href = protocol + "//" + hostUrl + res.logoutUrl;
      } else {
        next();
      }
    })
  }else{
    if (to.matched.some(r => r.meta.requireAuth)) {
      var loginInfo = localStorage.getItem('Admin-Token')
      if (loginInfo) {
        next()
      } else {
        //开发环境，直接next
        if (process.env.NODE_ENV === 'development') {
          next();
          return;
        }
        // if(window.parent){
        //   console.log(22222222,window.parent);
        // }
        // 重定向登录界面
        getConfigAsync().then(res=>{
          // console.log(res);
          //退出地址，通过配置文件配置
          // let hostUrl = window.location.host;
          // let protocol = window.location.protocol;
          let hostUrl =  window.top.location.host;//获取URL 的 hostname 和 port 号码
					let protocol =  window.top.location.protocol;//设置或获取 URL 的协议部分
          if (res.logoutUrl && res.logoutUrl != "") {
            window.top.location.href = protocol + "//" + hostUrl + res.logoutUrl;
            // window.location.href = protocol + "//" + hostUrl + res.logoutUrl;
          } else {
            next();
          }
        })
      }
    } else {
      next()
    }
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js